// PayableDetail.api.ts

import apiHandler from "../../../../api/core/apiHandler";

/**
 * Endpoint base:
 * /api/payables/details
 */
const PayableDetailApi = apiHandler("payables/details");

export default PayableDetailApi;